"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailPopTabType = void 0;
var DetailPopTabType;
(function (DetailPopTabType) {
    DetailPopTabType[DetailPopTabType["NONE"] = 0] = "NONE";
    DetailPopTabType[DetailPopTabType["VR"] = 1] = "VR";
    DetailPopTabType[DetailPopTabType["PHOTO"] = 2] = "PHOTO";
    DetailPopTabType[DetailPopTabType["FLOORPLAN"] = 3] = "FLOORPLAN";
    DetailPopTabType[DetailPopTabType["STREETMAP"] = 4] = "STREETMAP";
    DetailPopTabType[DetailPopTabType["NEARBY"] = 5] = "NEARBY";
    DetailPopTabType[DetailPopTabType["MORTGAGE"] = 6] = "MORTGAGE";
    DetailPopTabType[DetailPopTabType["VIDEO"] = 7] = "VIDEO";
})(DetailPopTabType = exports.DetailPopTabType || (exports.DetailPopTabType = {}));
